import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { ICredential } from '../../../viewmodels/AppViewModels';

export interface IAdminAccountImpersonationTokenRequest {
	accountId: string;
	userId: string;
	// Runs before the token request inside the same mutation, so its pending state covers granting access too.
	grantAccessFirst?: () => Promise<void>;
}

export const useAdminAccountImpersonationTokenMutation = ({
	onError,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({ accountId, userId, grantAccessFirst }: IAdminAccountImpersonationTokenRequest) => {
			await grantAccessFirst?.();
			return userSession.webServiceHelper.callAsync<ICredential>(
				`admin/account/${accountId}/CreateImpersonationToken?userId=${userId}`,
				'POST'
			);
		},
		onError,
	});
};
